export default __webpack_public_path__ + "media/zurb/img/legacy/strike/instructions-3-b1b931c26b865138afb1fcb63cc71031.jpg";